import { render } from "./indexConfigSimulatorComponent.vue?vue&type=template&id=a0cba0a0&scoped=true"
import script from "./indexConfigSimulatorComponent.vue?vue&type=script&lang=js"
export * from "./indexConfigSimulatorComponent.vue?vue&type=script&lang=js"

import "./indexConfigSimulatorComponent.vue?vue&type=style&index=0&id=a0cba0a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0cba0a0"]])

export default __exports__